( function () {
    'use strict';
    espresso.maps = {};
    espresso.maps.loadAPI = function ( strCallback ) {
        var gm = document.createElement( 'script' ),
            script = document.getElementsByTagName( 'script' )[ 0 ];
        gm.src = '//maps.google.com/maps/api/js?v=3&key=AIzaSyARmxTPmHHqSRyjEor0afPc5hBcfPw6zjI&callback=' + strCallback;
        script.parentNode.insertBefore( gm, script );
    };
    espresso.maps.init = function () {
        var jGoogleMaps = jQuery( '.e-google-map' );
        if ( jGoogleMaps.length > 0 ) {
            espresso.maps.loadAPI( 'espresso.maps.load' );
        }
    };
    espresso.maps.load = function () {
        var jGoogleMaps = jQuery( '.e-google-map' );
        var jSearchMarkerSettings = jQuery( '#js-e-maps-search-marker-settings' );
        if ( jGoogleMaps.length > 0 ) {
            jGoogleMaps.each( function ( index, element ) {
                var jGoogleMap = jQuery( element );
                // Save map settings on Map object
                jGoogleMap.data( 'settings', {
                    mapData: jGoogleMap.find( 'code.e-google-map-data' ),
                    mapZoom: ( jGoogleMap.data( 'zoom' ) !== undefined ? jGoogleMap.data( 'zoom' ) : 10 ),
                    mapRatio: window.outerWidth < 460 ? ( jGoogleMap.data( 'ratio' ) !== undefined ? jGoogleMap.data( 'mobile-ratio' ).split( ':' ) : '' ) : ( jGoogleMap.data( 'ratio' ) !== undefined ? jGoogleMap.data( 'ratio' ).split( ':' ) : '' ),
                    mapColor: co3.util.rgb2hex( ( jGoogleMap.data( 'color' ) !== undefined ? jGoogleMap.data( 'color' ) : jGoogleMap.css( 'color' ) ) ).replace( /^\#/, '' ),
                    mapDefaultMarkerColor: co3.util.rgb2hex( ( jGoogleMap.find( 'code.e-google-map-data' ).first().css( 'color' ) !== undefined ? jGoogleMap.find( 'code.e-google-map-data' ).first().css( 'color' ) : jGoogleMap.css( 'color' ) ) ).replace( /^\#/, '' ),
                    mapSearchIconColor: ( jSearchMarkerSettings.length > 0 ? co3.util.rgb2hex( jSearchMarkerSettings.css( 'color' ) ).replace( /^\#/, '' ) : '' ),
                    mapMaxZoomLevel: ( jGoogleMap.data( 'max-zoom-level' ) !== undefined ? jGoogleMap.data( 'max-zoom-level' ) : 12 ),
                    mapMinSearchRadius: ( jGoogleMap.data( 'min-search-radius' ) !== undefined ? jGoogleMap.data( 'min-search-radius' ) : 20 )
                } );
                if ( jGoogleMap.data( 'settings' ).mapRatio !== '' && jGoogleMap.data( 'settings' ).mapRatio.length === 2 ) {
                    jGoogleMap.css( 'padding-bottom', ( parseInt( jGoogleMap.data( 'settings' ).mapRatio[ 1 ] ) / parseInt( jGoogleMap.data( 'settings' ).mapRatio[ 0 ] ) * 100 ) + '%' );
                }
                var mapOptions = {
                    center: new google.maps.LatLng( 56.26392, 9.501785 ), //DK
                    scrollwheel: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    zoom: jGoogleMap.data( 'settings' ).mapZoom,
                    styles: [ {
                        featureType: 'administrative.land_parcel',
                        elementType: 'all',
                        stylers: [ {
                            visibility: 'off'
                        } ]
                    }, {
                        featureType: 'landscape.man_made',
                        elementType: 'all',
                        stylers: [ {
                            visibility: 'off'
                        } ]
                    }, {
                        featureType: 'poi',
                        elementType: 'labels',
                        stylers: [ {
                            visibility: 'off'
                        } ]
                    }, {
                        featureType: 'road',
                        elementType: 'labels',
                        stylers: [ {
                            visibility: 'simplified'
                        }, {
                            lightness: 20
                        } ]
                    }, {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [ {
                            hue: '#f49935'
                        } ]
                    }, {
                        featureType: 'road.highway',
                        elementType: 'labels',
                        stylers: [ {
                            visibility: 'simplified'
                        } ]
                    }, {
                        featureType: 'road.arterial',
                        elementType: 'geometry',
                        stylers: [ {
                            hue: '#fad959'
                        } ]
                    }, {
                        featureType: 'road.arterial',
                        elementType: 'labels',
                        stylers: [ {
                            visibility: 'off'
                        } ]
                    }, {
                        featureType: 'road.local',
                        elementType: 'geometry',
                        stylers: [ {
                            visibility: 'simplified'
                        } ]
                    }, {
                        featureType: 'road.local',
                        elementType: 'labels',
                        stylers: [ {
                            visibility: 'simplified'
                        } ]
                    }, {
                        featureType: 'transit',
                        elementType: 'all',
                        stylers: [ {
                            visibility: 'off'
                        } ]
                    }, {
                        featureType: 'water',
                        elementType: 'all',
                        stylers: [ {
                            color: '#acbcc9'
                        }, {
                            saturation: 30
                        }, {
                            lightness: 49
                        } ]
                    } ]
                };
                jGoogleMap.gmap( mapOptions ).bind( 'init', function () {
                    if ( jGoogleMap.is( '#js-e-map' ) === true ) {
                        jGoogleMap.gmap( 'microdata', 'http://schema.org/Organization', function ( result, item, index ) {
                            espresso.maps.helpers.addMicroDataMarkers( result, item, index, jGoogleMap );
                        } );
                        // Init dealer search
                        espresso.dealersearch.init();
                    }
                    else {
                        //Add single marker
                        var addr = jQuery( jGoogleMap.data( 'settings' ).mapData ).text();
                        addr = decodeURIComponent( addr.replace( /^http:\/\//, '' ).replace( /[\(zoom,ratio=:0-9\)\s\%]+$/i, '' ) );
                        espresso.maps.helpers.addAddressMarker( jGoogleMap, addr );
                    }
                } );
            } );
        }
    };
    espresso.maps.helpers = {};
    espresso.maps.helpers.icon = function ( type ) {
        var icons = {
            standard: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            },
            webshopBooking: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-webshop-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop / Book tid online'
            },
            webshop: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-webshop.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop'
            },
            booking: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Book tid online'
            },
            selected: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-selected.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            }
        };
        if ( type === undefined ) {
            return icons;
        }
        else {
            return icons[ type ];
        }
    };
    espresso.maps.helpers.addAddressMarker = function ( jGoogleMap, address ) {
        var gGeocoder = new google.maps.Geocoder();
        gGeocoder.geocode( {
            address: address
        }, function ( results, status ) {
            if ( status === google.maps.GeocoderStatus.OK ) {
                var latlng = results[ 0 ].geometry.location;
                var gMarkerOptions = {
                    bounds: false, // Special to jQuery.ui.map
                    position: latlng,
                    icon: espresso.maps.helpers.icon( 'standard' )
                };
                jGoogleMap.gmap( 'addMarker', gMarkerOptions );
                var map = jGoogleMap.gmap( 'get', 'map' );
                map.setCenter( latlng );
            }
        } );
    };
    espresso.maps.helpers.addMicroDataMarkers = function ( result, item, index, jGoogleMap ) {
        if ( result.geo !== undefined ) {
            // Parse coordinates
            var lat = parseFloat( result.geo[ 0 ].latitude );
            var lng = parseFloat( result.geo[ 0 ].longitude );
            if ( isNaN( lat ) || isNaN( lng ) || lat === 0 || lng === 0 ) {
                jGoogleMap.after( '<p> Error - lat/lng data not valid for this address: ' + result.name + ' </p>' );
                return;
            }
            if ( lat !== undefined && lng !== undefined ) {
                var latlng = new google.maps.LatLng( lat, lng );
                var gMarkerOptions = {
                    bounds: true, // Special to jQuery.ui.map
                    position: latlng,
                    icon: espresso.maps.helpers.icon( 'standard' )
                };
                var jMarker = jGoogleMap.gmap( 'addMarker', gMarkerOptions, function ( map, marker ) {
                    // find correct element and map it to marker
                    var jDealerElement = $( item );
                    // Add reference to dealer DOM element on Marker
                    marker.dealer = item;
                    if ( parseInt( jQuery( marker.dealer ).data( 'workshop-id' ) ) === parseInt( jQuery( 'meta[name="workshopID"]' ).attr( 'content' ) ) ) {
                        marker.icon = espresso.maps.helpers.icon( 'selected' );
                    }
                    else {
                        marker.icon = espresso.maps.helpers.icon( 'webshopBooking' );
                        /*
                        if ( jQuery( marker.dealer ).data( 'workshop-permissions' ) === 'webshop-booking' ) {
                            marker.icon = espresso.maps.helpers.icon( 'webshopBooking' );
                        }
                        else if ( jQuery( marker.dealer ).data( 'workshop-permissions' ) === 'webshop' ) {
                            marker.icon = espresso.maps.helpers.icon( 'webshop' );
                        }
                        else if ( jQuery( marker.dealer ).data( 'workshop-permissions' ) === 'booking' ) {
                            marker.icon = espresso.maps.helpers.icon( 'booking' );
                        }
                        else {
                            marker.icon = espresso.maps.helpers.icon( 'standard' );
                        }
                        */
                    }
                    // When clicking the dealer element, do what ever happens on marker click
                    var jClickElement = jDealerElement.find( '.js-e-map-list-dealer-name' );
                    jClickElement.on( 'click', function () {
                        $( marker ).triggerEvent( 'click' );
                        return false;
                    } );
                } );
                // Add event to Markers
                jMarker.click( function () {
                    espresso.maps.helpers.markerClick( jGoogleMap, this );
                } );
            }
        }
    };
    espresso.maps.helpers.markerClick = function ( jGoogleMap, marker ) {
        if ( jQuery( '.js-all-workshops-map-list' ).length ) {
            var jData = JSON.parse( jQuery.trim( jQuery( marker.dealer ).find( 'code' ).html() ) );
            //console.log(marker.dealer.dataset.dealerLink, jData);
            localStorage.setItem( 'myWorkshop', JSON.stringify( jData ) );

            if ( sessionStorage.getItem( 'return-reach' ) !== null ) {
                location.href = sessionStorage.getItem( 'return-reach' );
                sessionStorage.removeItem( 'return-reach' );
            }
            else {
                window.location.assign( '/' + marker.dealer.dataset.dealerLink );
            }
        }
        else {
            var jDealer = jQuery( marker.dealer );
            // Build content for infowindow
            var infoWindowContent = jDealer.find( '.js-e-maps-infowindow-content' ).html();
            jGoogleMap.gmap( 'openInfoWindow', {
                'content': infoWindowContent,
                maxWidth: 600
            }, marker );
            co3.util.scroll.toElement( jGoogleMap, 0, true, false );
            // Hook up to dealersearch if it's defined
            if ( espresso.dealersearch.markerClicked !== undefined ) {
                espresso.dealersearch.markerClicked();
            }
        }
    };
} )();
